export default __webpack_public_path__ + "static/media/ILPlatform_Teacher.145c4e17.jpg";